<template>
  <section class="margin-both-xl container">
    <div class="inner">
      <PageLogo :style="'height:'+imgHeight+'px; width: '+imgHeight*.95+'px'" class="side-log" />
      <div ref="sideInfo" class="side-info jost">
        <h2 class="titler jost--35 font--700">{{data.title}}</h2>
        <p class="desc jost--25 jost--500" v-html="data.content" v-if="data.content"/>
        <ColorLink :link="data.link" class="font--600 text-uppercase" color="green" :icon="false" :outlined="false"/>
      </div>
    </div>
  </section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import ColorLink from '@/components/elements/ColorLink'
import PageLogo from '@/components/elements/PageLogo';
import { mapGetters } from 'vuex';

export default {
  name: 'section-image',
  props: ['data'],
  data(){
    return {
      imgHeight: 0
    }
  },
  components:{
    WpImage,
    ColorLink,
    PageLogo
  },
  created() {
    window.addEventListener("resize", this.checkSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkSize);
  },
  mounted() {
    this.checkSize()
  },
  methods:{
    checkSize(){
      this.imgHeight = this.$refs.sideInfo.getBoundingClientRect().height
    }
  },
  computed:{
      ...mapGetters([
      'getOptions',
    ]),
  }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-highlight{
  .side-log{
    position: relative;
    img{
      width: 100%
    }
    @include mquery($phone){
      height: 125px !important;
      width: 100% !important;
      img{
        max-width: auto;
        height: inherit;
      }
    }

  }
  .side-info{
    max-width: 700px;
    width: 100%;
    padding-left: 100px;
    height: 100%;
    flex: 1;
    @include mquery($tablet){
      padding-left: 50px;
    }
    @include mquery($phone){
      padding-left: 0;
      margin-top: 20px;
    }
  }
  .inner{
    display: flex;
    position: relative;
    justify-content: center;
    @include mquery($phone){
      display: block;
      text-align: center;
    }
    .desc{
      margin: 0;
      margin-bottom: 35px;
    }
    .titler{
      margin-top: 0;
      margin-bottom: 25px;
    }
  }
}
</style>